export const LOCAL_STORAGE_KEY = {
  ACCESS_TOKEN: "accessToken",
  REFRESH_TOKEN: "refreshToken",
  PERMISSION_NAME: "permissionName",
  DUOC_UY_QUYEN: "DuocUyQuyen",
  PERMISSION_DECENTRALIZATION: "permissionDecentralization",
  USER_ID: "USER_ID",
  DANH_SACH_COT_DANH_MUC: "danhSachCotDanhMuc",
  DANH_SACH_COT_VAN_BAN_DEN: "danhSachCotVanBanDen",
  DANH_SACH_COT_VAN_BAN_DI: "danhSachCotVanBanDi",
  DANH_SACH_COT_HO_SO_LUU_TRU: "danhSachCotHoSoLuuTru",
  HSCV_PXL: "hoSoCongViecPhanXuLyOptions",
  IS_FROM_TRA_CUU: 'isDanhSachTraCuu',
  PAGE_SIZE_VAN_BAN_DEN: 'pageSizeVanBanDen',
  PAGE_SIZE_VAN_BAN_DI: 'pageSizeVanBanDi',
  DANH_SACH_COT_NHIEM_VU: 'danhSachCotNhiemVu',
};

export function getValueFromStorageByKey(key) {
  return JSON.parse(localStorage.getItem(key));
}

export function setValueToStorageByKey(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

export function removeValueToStorageByKey(key) {
  localStorage.removeItem(key);
}
